<div fxLayout="row" fxLayoutGap="1rem">
  <div fxFlex="100" fxLayout="column" fxLayoutAlign="space-around start">
    @if (!lastUpdatedIsNull()) {
      <span>Ihre letzte Aktualisierung fand am <span class="bold">{{lastUpdated | date:'dd.MM.yyyy'}}</span> statt.</span>
    }
    <span>Bitte halten Sie Ihren Datenstand stets aktuell.</span>
    @if (checkDataValidity()) {
      <span>Ihre letzte Datenaktualisierung ist mehr als {{DATE_VALIDTIY}} Tage alt.</span>
    }
  </div>
</div>
